import { PatientCareProviderModel } from "one-card-pcp";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * pcp Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    let pdata: PatientCareProviderModel[] = [];

    let result :any = {
        pcp:pdata,
        error:undefined

    }
    const { log } = context;
    if (response && (response.status >= 400 || response.type == "error")) {
       result.error=response;
    }
    if (response && response.length > 0) {
        response.forEach((pcpdata:any)=>{
            let pcpobj: PatientCareProviderModel = {
                name:"",
                department:[],
                center:""
            };
            console.log(pcpdata,"pitchpcp")
            //OR condition was added for NYCHHC as the response was different
            pcpobj.name = pcpdata?.PhysicianName || pcpdata?.Name;
            pcpobj.department = pcpdata?.Speciality || pcpdata?.Type;
            pcpobj.center = pcpdata?.Center;
            pdata.push(pcpobj)
        })
    }
    result.pcp=pdata;
    log.debug(
        "ccw-gadget,pcp-cerner",
        "pcp-cerner transforamtion response ", {
        result
    });
    return result;
}